export const SAVE = 'step11.SAVE';
export const VALUE_CHANGED = 'step11.VALUE_CHANGED';
export const LOAD = 'step11.VALUE_LOAD';
export const NEXT = 'step11.NEXT';
export const RESET = 'step11.RESET';
export const RESET_SUB_BENEFIT = 'step11.RESET_SUB_BENEFIT';
export const RESET_BENEFIT_OTHER = 'step11.RESET_BENEFIT_OTHER';


export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '7',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step11/constants.js